module.exports = __webpack_public_path__ + "static/media/undraw_pair_programming_njlp.e8ea49cf.svg";